import React, { useState } from 'react';
import styles from './Faq.module.css';

const FAQS = [
  {
    question: 'Which countries and regions does BETA Edge serve?',
    answer:
      'BETA Edge delivers software development, IT consulting and business advisory services to clients worldwide, with active engagements across India, Singapore, New Zealand, Japan, Malaysia, the UK, Canada and the USA.',
  },
  {
    question: 'What services does BETA Edge offer?',
    answer:
      'We offer custom software development, mobile app development, ERP implementation, business automation, AI-powered systems, digital transformation strategy, business analytics and IT consulting for startups, SMEs and enterprises.',
  },
  {
    question: 'Why do international clients choose an India-based team?',
    answer:
      'Clients get access to experienced engineering talent with INR-based billing, which protects budgets from currency volatility while keeping delivery quality and communication standards on par with global agencies.',
  },
  {
    question: 'Does BETA Edge work with startups as well as large enterprises?',
    answer:
      'Yes. Our engagements range from MVP builds and product advisory for early-stage startups to enterprise-grade digital transformation and ERP rollouts for established organizations.',
  },
  {
    question: 'How is BETA Edge rated by past clients?',
    answer:
      'BETA Edge maintains a 5-star average rating across 15 verified client reviews spanning Singapore, New Zealand, Japan, India, Malaysia, the UK, Canada and the USA between 2023 and 2026.',
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <section className={styles.wrapper} aria-labelledby="faq-heading">
      <div className={styles.container}>
        <h2 id="faq-heading" className={styles.title}>
          Frequently Asked Questions
        </h2>

        <div className={styles.list}>
          {FAQS.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className={styles.item}>
                <button
                  type="button"
                  className={styles.question}
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${idx}`}
                >
                  <span>{faq.question}</span>
                  <span className={styles.icon}>{isOpen ? '\u2212' : '+'}</span>
                </button>
                {isOpen && (
                  <p id={`faq-answer-${idx}`} className={styles.answer}>
                    {faq.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const FAQ_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default Faq;
